<template>
  <div v-if="data">
    <v-layout row wrap class="mt-3 px-5">
   
      <v-flex xs12 sm12 class="form-control" style="display: flex">
        <div style="width: 10%;"></div>
        <Typography medium style="width: 40%" h5 label="ชื่อบริษัท :" />
        <Typography medium h5 :label="data.techproviderName ? data.techproviderName : '-'" />
      </v-flex>
      <!-- ex_select = " ,tech.phone,tech.salesrepresentatives,tech.website,tech.name"; -->
      <v-flex xs12 sm12 class="form-control" style="display: flex;">
        <div style="width: 10%;"></div>
        <Typography medium style="width: 40%" h5 label="เว็บไซต์ :" />
        <Typography medium h5 :label="data.website ? data.website : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex;">
        <div style="width: 10%;"></div>
        <Typography medium style="width: 40%" h5 label="เบอร์ :" />
        <Typography medium h5 :label="data.phone ? data.phone : '-'" />
      </v-flex>

      <v-flex xs12 sm12 class="form-control" style="display: flex;">
        <div style="width: 10%;"></div>
        <Typography medium style="width: 40%" h5 label="ตัวแทนขาย :" />
        <Typography medium h5 :label="data.salesrepresentatives ? data.salesrepresentatives : '-'" />
      </v-flex>
      
    </v-layout>
  </div>
</template>

<script>
import UploadProfile from '@/components/elements/UploadProfile.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import Typography from '@/components/elements/Typography.vue'
export default {
  props: {
    infodata: {
      default: null
    },
    isEdit: {
      default: Boolean
    }
  },
  components: {
    UploadProfile,
    DropdownMenu,
    DatePickerWithoutButton,
    Typography
  },
  data() {
    return {
      isEdit: false,
      tempdata: '',
      loading: false,
      data: null
    }
  },
  mounted() {
    this.data = { ...this.infodata, created: moment(this.infodata.created_at).format('YYYY-MM-DD') }
    this.isEdit = this.isEdit
  },
  methods: {
    async editData() {
      this.loading = true
      this.$swal
        .fire({
          html:
            '<div class="primary--text bold7 fs-24">ยืนยันการบันทึกข้อมูล</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result =>  {
          if (result.value) {
              try  {
                this.$store.dispatch('depamemberinfo', this.data)
                this.$emit('saveedit', this.data)
                this.isEdit = false
              } catch (error) {}
          }
        })
      this.loading = false
    },
    showEdit() {
      this.tempdata = JSON.stringify(this.data)
      this.isEdit = true
    },
    cancelEdit() {
      this.$emit('closemodal')
      this.data = JSON.parse(this.tempdata)
      this.isEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.greytext {
  color: rgb(173, 173, 173);
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/memberInfo/MemberInfoEditInformation.vue